.container {
  position: relative;
}

.input-group {
  position: relative;
  --dds-input-absolute-el-left-xsmall: var(--dds-spacing-x0-25);
  --dds-input-absolute-el-left-small: var(--dds-spacing-x0-5);
  --dds-input-absolute-el-left-medium: var(--dds-spacing-x0-75);
  --dds-input-absolute-el-left-large: var(--dds-spacing-x0-75);
  --dds-input-btn-right: var(--dds-spacing-x0-25);
  --dds-input-btn-right-padding-xsmall: var(--dds-spacing-x0-125);
  --dds-input-btn-right-padding-small: var(--dds-spacing-x0-25);
  --dds-input-btn-right-padding-medium: var(--dds-spacing-x0-5);
  --dds-input-btn-right-padding-large: var(--dds-spacing-x0-75);
  --dds-input-absolute-el-right-xsmall: var(--dds-spacing-x0-25);
  --dds-input-absolute-el-right-small: var(--dds-spacing-x0-5);
  --dds-input-absolute-el-right-medium: var(--dds-spacing-x0-75);
  --dds-input-absolute-el-right-large: var(--dds-spacing-x0-75);

  & > svg {
    pointer-events: none;
  }
}

:where(.input) {
  position: relative;
  color: var(--dds-color-text-default);
  border: 1px solid var(--dds-color-border-default);
  background-color: var(--dds-color-surface-default);
  padding: var(--dds-spacing-x0-75) var(--dds-spacing-x1)
    var(--dds-spacing-x0-75) var(--dds-spacing-x0-75);
  border-radius: var(--dds-border-radius-input);
  margin: 0;
  box-sizing: border-box;
  box-shadow: none;
  @media (prefers-reduced-motion: no-preference) {
    transition:
      box-shadow var(--dds-motion-micro-state),
      border-color var(--dds-motion-micro-state),
      background-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
  &[type='text'],
  &[type='password'],
  &[type='number'],
  &[type='tel'],
  &[type='date'],
  &[type='url'],
  &[type='email'],
  &[type='search'],
  &[type='datetime-local'] {
    -webkit-appearance: none;
  }

  &:hover:enabled:read-write:not(:focus-visible):not(.disabled):not(
      .read-only
    ) {
    border-color: var(--dds-color-border-action-hover);
    box-shadow: 0 0 0 1px var(--dds-color-border-action-hover);
  }
}

:where(.input--stateful) {
  -webkit-appearance: textfield;

  &:not(.disabled).read-only,
  &:enabled:read-only {
    box-shadow: none;
    border: 1px solid var(--dds-color-border-default);
    background-color: var(--dds-color-surface-field-disabled);
    color: var(--dds-color-text-medium);
    cursor: default;
  }

  &.disabled,
  &:disabled {
    box-shadow: none;
    border: 1px solid var(--dds-color-border-subtle);
    background-color: var(--dds-color-surface-field-disabled);
    color: var(--dds-color-text-subtle);
    cursor: not-allowed;
  }
}

:where(.input--hover:hover) {
  border-color: var(--dds-color-border-action-hover);
  box-shadow: 0 0 0 1px var(--dds-color-border-action-hover);
}

:where(.input--stateful-danger) {
  border-color: var(--dds-color-border-danger);
  box-shadow: 0 0 0 1px var(--dds-color-border-danger);

  &:not(.disabled):hover:not(:focus-within),
  &:hover:enabled:read-write:not(:focus-within) {
    border-color: var(--dds-color-border-danger);
    box-shadow: 0 0 0 1px var(--dds-color-border-danger);
  }

  &:not(.disabled):focus-within,
  &:focus-within:enabled:read-write,
  &:hover:focus-within:enabled:read-write,
  &:active:enabled:read-write {
    border-color: 1px solid var(--dds-color-border-default);
  }
}

:where(.input--large) {
  padding: var(--dds-spacing-x0-75);
  min-height: var(--dds-size-height-input-large);
}

:where(.input--medium) {
  padding: var(--dds-spacing-x0-5) var(--dds-spacing-x0-75);
  min-height: var(--dds-size-height-input-medium);
}

:where(.input--small) {
  padding: var(--dds-spacing-x0-25) var(--dds-spacing-x0-5);
  min-height: var(--dds-size-height-input-small);
}

:where(.input--xsmall) {
  padding: var(--dds-spacing-x0-125) var(--dds-spacing-x0-25);
  min-height: var(--dds-size-height-input-xsmall);
}

:where(.input-with-icon--large) {
  padding-left: calc(
    var(--dds-input-absolute-el-left-large) + var(--dds-size-icon-component) +
      var(--dds-spacing-lg-icon-text-gap)
  );
}

:where(.input-with-icon--medium) {
  padding-left: calc(
    var(--dds-input-absolute-el-left-medium) + var(--dds-size-icon-component) +
      var(--dds-spacing-md-icon-text-gap)
  );
}

:where(.input-with-icon--small) {
  padding-left: calc(
    var(--dds-input-absolute-el-left-small) + var(--dds-size-icon-component) +
      var(--dds-spacing-sm-icon-text-gap)
  );
}

:where(.input-with-icon--xsmall) {
  padding-left: calc(
    var(--dds-input-absolute-el-left-xsmall) + var(--dds-size-icon-component) +
      var(--dds-spacing-xs-icon-text-gap)
  );
}

:where(.input-with-el-right--large) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-large) + var(--dds-size-icon-component)
  );
}

:where(.input-with-el-right--medium) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-medium) + var(--dds-size-icon-component)
  );
}

:where(.input-with-el-right--small) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-small) + var(--dds-size-icon-component)
  );
}

:where(.input-with-el-right--xsmall) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-xsmall) + var(--dds-size-icon-component)
  );
}

:where(.input-with-btn-right--large) {
  padding-inline-end: calc(
    var(--dds-input-btn-right) + var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-large)
  );
}

:where(.input-with-btn-right--medium) {
  padding-inline-end: calc(
    var(--dds-input-btn-right) + var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-medium)
  );
}

:where(.input-with-btn-right--small) {
  padding-inline-end: calc(
    var(--dds-input-btn-right) + var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-small)
  );
}

:where(.input-with-btn-right--xsmall) {
  padding-inline-end: calc(
    var(--dds-input-btn-right) + var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-xsmall)
  );
}

:where(.input-with-icon-and-button-right--large) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-large) + 2 *
      var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-large)
  );
}

:where(.input-with-icon-and-button-right--medium) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-medium) + 2 *
      var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-medium)
  );
}

:where(.input-with-icon-and-button-right--small) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-small) + 2 *
      var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-small)
  );
}

:where(.input-with-icon-and-button-right--xsmall) {
  padding-inline-end: calc(
    var(--dds-input-absolute-el-right-xsmall) + 2 *
      var(--dds-size-icon-component) + 2 *
      var(--dds-input-btn-right-padding-xsmall)
  );
}

:where(.input-group__absolute-el-right--large) {
  right: var(--dds-input-absolute-el-left-large);
}

:where(.input-group__absolute-el-right--medium) {
  right: var(--dds-input-absolute-el-left-medium);
}

:where(.input-group__absolute-el-right--small) {
  right: var(--dds-input-absolute-el-left-small);
}

:where(.input-group__absolute-el-right--xsmall) {
  right: var(--dds-input-absolute-el-left-xsmall);
}

:where(.input-group__btn-right) {
  right: var(--dds-input-btn-right);
}

:where(.input-group__btn-right-with-right-icon--xsmall) {
  right: calc(
    var(--dds-input-absolute-el-right-xsmall) + var(--dds-size-icon-component)
  );
}

:where(.input-group__btn-right-with-right-icon--small) {
  right: calc(
    var(--dds-input-absolute-el-right-small) + var(--dds-size-icon-component)
  );
}

:where(.input-group__btn-right-with-right-icon--medium) {
  right: calc(
    var(--dds-input-absolute-el-right-medium) + var(--dds-size-icon-component)
  );
}

:where(.input-group__btn-right-with-right-icon--large) {
  right: calc(
    var(--dds-input-absolute-el-right-large) + var(--dds-size-icon-component)
  );
}

:where(.input--with-affix) {
  gap: var(--dds-spacing-x1);
}

:where(.input-group__absolute-el) {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: var(--dds-zindex-absolute-element);
  color: var(--dds-color-icon-default);
}

:where(.input-group__absolute-el--large) {
  left: var(--dds-input-absolute-el-left-large);
}

:where(.input-group__absolute-el--medium) {
  left: var(--dds-input-absolute-el-left-medium);
}

:where(.input-group__absolute-el--small) {
  left: var(--dds-input-absolute-el-left-small);
}

:where(.input-group__absolute-el--xsmall) {
  left: var(--dds-input-absolute-el-left-xsmall);
}
